// DataContext.js

import React, { createContext, useState } from 'react';

// Dados iniciais
const initialData = {
  // atendentes que estao como disponiveis
  available: [
    // { uuid: '3fdd83ec-bdc7-4051-bc9f-5e4d4c73800f', name: 'Maria', avatar: '/img/avatar1.jpeg' },
    // { uuid: 'ac2d3a9c-ec76-4b2e-aef4-a49cfeb64208', name: 'Júlia', avatar: '/img/avatar4.jpeg' },
    // { uuid: '218c4665-8399-44bd-8470-5c352d9f985f', name: 'Lucas', avatar: '/img/avatar11.jpeg' },
  ],
  // atendentes que estao atendendo
  inService: [
    // { uuid: 'a34ca7ea-6111-45b4-b6a5-711853028a54', name: 'Lara', avatar: '/img/avatar5.jpeg', startedAt: '2025-01-27T17:47:57.181Z' },
    // { uuid: '7f848941-ae64-4102-8668-d1e55a55f3ef', name: 'João', avatar: '/img/avatar12.jpeg', startedAt: new Date().toISOString() },
  ],
  // atendentes que estao indisponiveis
  unavailable: [
    // { uuid: '9a246a83-9c49-4518-a0f3-fcb01245901c', name: 'Mara', avatar: '/img/avatar7.jpeg' },
    // { uuid: '359da2f8-4661-4429-8234-988b53b4fee9', name: 'Thiago', avatar: '/img/avatar13.jpeg' },
    // { uuid: '005c194a-4610-49b4-ba8a-1e7606f5e0e0', name: 'Tales', avatar: '/img/avatar8.jpeg' },
    // { uuid: 'e9b88a82-25e7-4948-9b30-897b49fa8225', name: 'Mariana', avatar: '/img/avatar14.jpeg' },
  ],
  // aqui sao as opcoes disponiveis para o dialog
  dialogOptions: {
    // available_inService: {
    //   label: 'Por que está atendendo?',
    //   options: [
    //     {
    //       label: "Preferência do cliente",
    //       value: "preferencia_cliente",
    //       icon: "ShoppingCart",
    //       options: [],
    //     },
    //     {
    //       label: "Operacional",
    //       value: "operacional",
    //       icon: "Build",
    //       options: [
    //         {
    //           label: "Equipe indisponível",
    //           value: "equipe_indisponivel",
    //           icon: "GroupOff",
    //           options: [
    //             { label: "Férias", value: "ferias", icon: "BeachAccess" },
    //             { label: "Doença", value: "LocalHospital" },
    //           ],
    //         },
    //         { label: "Problemas técnicos", value: "BugReport" },
    //       ],
    //     },
    //     {
    //       label: "Retorno cliente",
    //       value: "retorno_cliente",
    //       icon: "Autorenew",
    //       options: [],
    //     },
    //   ],
    // },
    
    // inService_available: {
    //   label: 'Por que está voltando para a fila?',
    //   options: [
    //     {
    //       label: "Sucesso",
    //       value: "sucesso",
    //       icon: "CheckCircle",
    //     },
    //     {
    //       label: "Não convertido",
    //       value: "naoConvertido",
    //       icon: "Cancel",
    //       options: [
    //         {
    //           label: "Cor",
    //           value: "naoConvertido_cor",
    //           icon: "Palette",
    //         },
    //         {
    //           label: "Tamanho",
    //           value: "naoConvertido_tamanho",
    //           icon: "Straighten",
    //         },
    //         {
    //           label: "Entrou e saiu",
    //           value: "naoConvertido_entrouesaiu",
    //           icon: "ExitToApp",
    //           options: [
    //             {
    //               label: "Não deu tempo de abordar",
    //               value: "naoConvertido_entrouesaiu_naoDeuTempo",
    //               icon: "HourglassTop",
    //             },
    //             {
    //               label: "Não deu atenção",
    //               value: "naoConvertido_entrouesaiu_naoDeuAtencao",
    //               icon: "VisibilityOff",
    //             },
    //           ]
    //         },
    //         {
    //           label: "Não trabalha com o produto",
    //           value: "naoConvertido_naoTrabalhaComProduto",
    //           icon: "DoNotDisturb",
    //         },
    //         {
    //           label: "Pesquisa",
    //           value: "naoConvertido_pesquisa",
    //           icon: "Search",
    //           options: [
    //             {
    //               label: "Para presente",
    //               value: "naoConvertido_pesquisa_paraPresente",
    //               icon: "Redeem",
    //             },
    //             {
    //               label: "Para o próprio cliente",
    //               value: "naoConvertido_pesquisa_paraOProprio",
    //               icon: "Person",
    //             },
    //           ]
    //         },
    //         {
    //           label: "Não agradou",
    //           value: "naoConvertido_naoAgradou",
    //           icon: "SentimentDissatisfied",
    //         },
    //         {
    //           label: "Preço",
    //           value: "naoConvertido_preco",
    //           icon: "AttachMoney",
    //         },
    //         {
    //           label: "Reserva",
    //           value: "naoConvertido_reserva",
    //           icon: "Event",
    //         },
    //       ],
    //     },
    //     {
    //       label: "Troca",
    //       value: "troca",
    //       icon: "SwapHoriz",
    //       options: [
    //         {
    //           label: "Troca não convertida",
    //           value: "troca_naoConvertida",
    //           icon: "RemoveCircle",
    //         },
    //         {
    //           label: "Troca sucesso",
    //           value: "troca_sucesso",
    //           icon: "CheckCircleOutline",
    //         },
    //         {
    //           label: "Troca normal",
    //           value: "troca_normal",
    //           icon: "CompareArrows",
    //         },
    //       ],
    //     },
    //     {
    //       label: "Outros",
    //       value: "outros",
    //       icon: "MoreHoriz",
    //       options: [
    //         {
    //           label: "Vendedor fora da vez",
    //           value: "outros_foraDaVez",
    //           icon: "WatchLater",
    //         },
    //         {
    //           label: "Cancelar atendimento",
    //           value: "outros_cancelarAtendimento",
    //           icon: "Close",
    //         },
    //         {
    //           label: "Reserva de outro vendedor",
    //           value: "outros_reservaDeOutroVendedor",
    //           icon: "Assignment",
    //         },
    //         {
    //           label: "Retorno da reserva",
    //           value: "outros_retornoDaReserva",
    //           icon: "Replay",
    //         },
    //       ],
    //     },
    //   ],
    // }
    
    
  },
};

// Criando o contexto
export const DataContext = createContext();

// Criando o Provider
export const DataProvider = ({ children }) => {
  const [data, setData] = useState(initialData);

  return (
    <DataContext.Provider value={{ data, setData }}>
      {children}
    </DataContext.Provider>
  );
};
